import { render, staticRenderFns } from "./ModelInfoModal.vue?vue&type=template&id=9d4bbe0a"
import script from "./ModelInfoModal.vue?vue&type=script&lang=js"
export * from "./ModelInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports